import Vue from "vue";

// import "./styles/all.styl";
// import Calculator from './demo/CalculatorView/index.vue';
// const i18n = require('ksc-i18n');
import {$trans} from 'ksc-i18n';
const {configure} = require('kpc/components/utils');
// Vue.use(i18n.VueTransPlugin, window.kvm_lang_dict || {});
Vue.use({
    install(Vue) {
        Vue.$trans = Vue.prototype.$trans = $trans;
    }
});

// 指定kpc-tooltip的样式(组件样式需要这个wrapper)
configure({useWrapper: true});

export const Calculator = require('./demo/CalculatorView/index.vue').default



export default {
    loadI18nDict(dict) {
        Vue.$trans.updateDict(dict);
    },
    exportStore() {
        const PublicBusinessComponentsStep1 = require('./store/create/step1/index').default;
        const PublicBusinessComponentsStep2 = require('./store/create/step2/index').default;
        const PublicBusinessComponentsStep3 = require('./store/create/step3/index').default;
        const PublicBusinessComponentsStep4 = require('./store/create/step4/index').default;
        const PublicBusinessComponentsCommon = require('./store/common/index').default;

        return {
            __pbc__: {
                namespace: true,
                modules: {
                    step1: PublicBusinessComponentsStep1,
                    step2:PublicBusinessComponentsStep2,
                    step3: PublicBusinessComponentsStep3,
                    step4: PublicBusinessComponentsStep4,
                    common: PublicBusinessComponentsCommon
                }
            }
        }
    },

    // Calculator
}